import React, {useState, useEffect} from 'react'

import classes from './ActivityFeedback.module.css'
import clsx from 'clsx'
import Texts from 'react-sdk/Texts';
import SoundPlayer from 'react-sdk/SoundPlayer';

const ActivityFeedback = ({children, correct, points}) => {
  useEffect(() => {
    SoundPlayer.playSound(correct ? "activite_good" : "activite_wrong")
  }, []);

  return (
    <div className={clsx(classes.ActivityFeedback, correct ? classes.correct : classes.wrong)}>
      {!children &&
      <span>
      {correct ?
          Texts.get("feedback-correct") :
          Texts.get("feedback-wrong")}
      </span>}

      <span>{children}</span>

      {points > 0 && <div className={classes.points}>+{points}</div>}
    </div>
  );
};

export default ActivityFeedback;
